/** Figma Filtro/Lista (11464:764224): 8 opções de 31 + 7 gaps de 2 + padding 3,5 nas duas pontas; o Prime grava o `max-height` inline. */
export const VALUES_LIST_SCROLL_HEIGHT = "269px";

/** Ainda não há definição de como os filtros serão salvos: "Salvar filtro" fica desabilitado até a decisão (o dialog segue pronto). */
export const CAN_SAVE_FILTER = false;
